import { Skeleton } from "@/components/ui/skeleton";

/**
 * Public routes load their page bundles lazily. This reserved shell prevents the
 * footer from appearing directly below a small spinner before a full route mounts.
 */
export function RouteLoadingSkeleton() {
  return (
    <section
      aria-busy="true"
      aria-label="Loading page"
      className="min-h-[calc(100svh-4rem)] overflow-hidden bg-background"
      data-testid="route-loading-skeleton"
    >
      <div className="relative h-48 overflow-hidden border-b border-border/40 md:h-64">
        <Skeleton className="absolute inset-0 rounded-none bg-muted/50" />
        <div className="container absolute inset-x-0 bottom-0 space-y-3 pb-7">
          <Skeleton className="h-9 w-64 max-w-[78%] bg-muted/70 md:h-11 md:w-96" />
          <Skeleton className="h-4 w-80 max-w-[90%] bg-muted/60" />
        </div>
      </div>

      <div className="border-b border-border/40 bg-background/95 py-3">
        <div className="container flex flex-wrap gap-2">
          <Skeleton className="h-10 min-w-48 flex-1 bg-muted/60" />
          <Skeleton className="h-10 w-24 bg-muted/60" />
          <Skeleton className="h-9 w-32 bg-muted/50" />
          <Skeleton className="h-9 w-32 bg-muted/50" />
        </div>
      </div>

      <div className="container space-y-6 py-8">
        <Skeleton className="h-5 w-44 bg-muted/55" />
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }, (_, index) => (
            <div key={index} className="overflow-hidden rounded-xl border border-border/40 bg-card/30">
              <Skeleton className="h-40 rounded-none bg-muted/55" />
              <div className="space-y-3 p-5">
                <Skeleton className="h-5 w-4/5 bg-muted/55" />
                <Skeleton className="h-4 w-2/5 bg-muted/45" />
                <Skeleton className="h-9 w-full bg-muted/45" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
